import { Library } from "lucide-react";
import { cn } from "@/lib/utils";

type SidebarBrandProps = {
  collapsed: boolean;
  logoUrl?: string | null;
  slug?: string | null;
  libraryName?: string | null;
};

export function SidebarBrand({ collapsed, logoUrl, slug, libraryName }: SidebarBrandProps) {
  if (!slug) {
    if (collapsed) return null;
    return <h1 className="truncate font-heading text-xl font-bold text-slate-900">PhiloLMS</h1>;
  }

  const logoAlt = libraryName ? `${libraryName} logo` : "Library logo";

  return (
    <div
      className={cn("flex min-w-0 items-center gap-2.5", collapsed && "justify-center")}
      title={collapsed ? slug : undefined}
    >
      {logoUrl ? (
        <img src={logoUrl} alt={logoAlt} className="h-8 w-8 shrink-0 rounded-md object-contain" />
      ) : (
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary">
          <Library className="h-4 w-4" aria-hidden />
        </span>
      )}
      {!collapsed && (
        <span className="truncate font-heading text-sm font-semibold text-slate-900">{slug}</span>
      )}
    </div>
  );
}
